import { union } from "superstruct";

import InstagramImageStorySchema from "./InstagramImageStorySchema";
import InstagramVideoStorySchema from "./InstagramVideoStorySchema";

const InstagramStorySchema = union([
    InstagramVideoStorySchema,
    InstagramImageStorySchema,
]);

export default InstagramStorySchema;
